/**
 * PageHeader — consistent page title block with optional subtitle + right-side actions.
 * Reused across every module page so headers stay visually identical.
 */
export default function PageHeader({ title, subtitle, icon: Icon, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div className="flex items-center gap-3 min-w-0">
        {Icon && (
          <div
            className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{
              background: "var(--color-primary-tint)",
              color: "var(--color-primary)",
            }}
          >
            <Icon className="w-5 h-5" />
          </div>
        )}
        <div className="min-w-0">
          <h1 className="text-xl font-bold text-text_primary leading-tight truncate">{title}</h1>
          {subtitle && <p className="text-sm text-text_muted mt-0.5 truncate">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
    </div>
  );
}
